export function canonicalizePathName(pathname: string): string {
    return pathname.replace(/(?:\/all|\/1)+$/, '');
}
